export default {
      id: "logo-uni-usage",
      viewBox: "0 0 71 71",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#logo-uni",
      toString: function () {
        return this.url;
      }
    }